//#region src/customer_account_usage.ts
var CustomerAccountsUsage = /* @__PURE__ */ function(CustomerAccountsUsage) {
	CustomerAccountsUsage[CustomerAccountsUsage["Disabled"] = 0] = "Disabled";
	CustomerAccountsUsage[CustomerAccountsUsage["Enabled"] = 1] = "Enabled";
	return CustomerAccountsUsage;
}(CustomerAccountsUsage || {});
//#endregion
export { CustomerAccountsUsage };

//# sourceMappingURL=customer_account_usage.js.map